/**
 * OHT News Notifications Frontend Script Entry Point
 */
import React, { useState } from 'react';
// Use the older ReactDOM import for the original structure
import ReactDOM from 'react-dom'; 

// Import CSS
import './css/frontend.css';

// Import the main sidebar component (ensure this path is correct)
import SidebarPanel from './components/SidebarPanel'; // Should resolve to .js now

console.log('OHT Frontend Script Loaded.');
// console.log('Data from PHP:', window.ohtFrontendData); // <-- Comment out this line

// Find the trigger button and the container
const triggerButton = document.querySelector(window.ohtFrontendData?.triggerSelector || '#oht-notification-bell-trigger');
const sidebarContainer = document.getElementById(window.ohtFrontendData?.sidebarContainerId || 'oht-notification-sidebar-container');

if (triggerButton && sidebarContainer) {
    console.log('Trigger and container found.');

    // Render the SidebarPanel component using the App wrapper
    // to control its visibility via props passed down
    function App() {
        const [isSidebarOpen, setIsSidebarOpen] = useState(false);

        // Add listener to the button *outside* the React component
        // to control the state within this App wrapper
        React.useEffect(() => {
            const openSidebar = (event) => {
                console.log('>>> Bell Button Click/Tap Detected <<<', event);
                console.log('Trigger clicked, setting sidebar to open via App wrapper.');
                setIsSidebarOpen(true);
            };
            triggerButton.addEventListener('click', openSidebar);
            // Add touchstart listener for mobile compatibility
            triggerButton.addEventListener('touchstart', openSidebar); 
            
            // Cleanup listener on component unmount
            return () => {
                 console.log('Cleaning up App wrapper listener.');
                 triggerButton.removeEventListener('click', openSidebar);
                 // Remove touchstart listener on cleanup
                 triggerButton.removeEventListener('touchstart', openSidebar);
            };
        }, []); // Empty dependency array ensures this runs only once

        // Pass isOpen and onClose props to the original SidebarPanel.js component
        return <SidebarPanel isOpen={isSidebarOpen} onClose={() => setIsSidebarOpen(false)} />;
    }

    // Use the original ReactDOM.render method
    ReactDOM.render(<App />, sidebarContainer);

} else {
    if (!triggerButton) console.error('Notification bell trigger element not found.');
    if (!sidebarContainer) console.error('Notification sidebar container element not found.');
}

/**
 * Register the service worker.
 */
function registerServiceWorker() {
  if ('serviceWorker' in navigator && 'PushManager' in window) {
    console.log('Service Worker and Push is supported');
    
    // Get SW path from localized data
    const swPath = window.ohtFrontendData?.swPath;
    if (!swPath) {
        console.error('Service Worker path not found in localized data.');
        return;
    }

    navigator.serviceWorker.register(swPath)
    .then(function(swReg) {
      console.log('Service Worker is registered', swReg);
      // You might store swReg globally or pass it down if needed immediately
    })
    .catch(function(error) {
      console.error('Service Worker Error', error);
    });
  } else {
    console.warn('[registerServiceWorker] Push messaging is not supported (navigator.serviceWorker or PushManager missing).');
    // Optionally update UI to indicate push is not supported
  }
}

// Call registration function when the script loads
registerServiceWorker(); 